import React, { useCallback } from 'react';
import { ComboBoxMultiselectParam, Form, Row, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import {
  GroupPreviewMultiSelectComboBoxForForm2,
  ListBoxModifier,
} from '../../../components/molecules/Form/components/ComboBox';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';

export type AdditionalReadRestrictionsFormTypes = ComboBoxMultiselectParam<'restrictedUserGroups', any> & {
  hasReadProtectedItems: boolean;
};

type AdditionalReadRestrictionsFormProps = {
  form: SonForm<AdditionalReadRestrictionsFormTypes>;
};

export default function AdditionalReadRestrictionsForm({ form }: AdditionalReadRestrictionsFormProps) {
  const { t } = useSonTranslation('PageReadRestrictions');

  const { refresh } = useRefreshBlock();
  const { closeModal } = useModalContext();
  const refreshAndClose = useCallback(() => {
    refresh();
    closeModal();
  }, [closeModal, refresh]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);

  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedRefreshAndClose });

  const restrictedUserGroupsParam = params.findByName('restrictedUserGroups');

  return (
    <Form {...formProps}>
      {restrictedUserGroupsParam && (
        <Row>
          <GroupPreviewMultiSelectComboBoxForForm2
            name={restrictedUserGroupsParam.name}
            value={restrictedUserGroupsParam.value}
            suggestUrl={restrictedUserGroupsParam.comboBoxUrl.url}
            labelTitle={t('form.groups.label')}
            required={restrictedUserGroupsParam.required}
            hasReadProtectedItems={restrictedUserGroupsParam.hasReadProtectedItems}
            modifierListBox={ListBoxModifier.RELATIVE}
          />
        </Row>
      )}
      <SubmitButton
        buttonLabel={t('form.submitButton')}
        messageSuccess={t('form.status.success')}
        messageSending={t('form.status.sending')}
        messageFail={t('form.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
